import React from "react";
import Icon from "@/components/icons";

export interface ListInfoProps {
  title: string;
  details: {
    heading: string;
    description: string;
  }[];
  titleFontClass?: string;
  descriptionFontClass?: string;
  descriptionListClass?: string;
  containerClass?: string;
  iconColor?: string;
}

export default function BulletListInfo({
  title,
  details,
  titleFontClass = "",
  descriptionFontClass = "",
  descriptionListClass = "",
  containerClass = "",
  iconColor = "white",
}: ListInfoProps) {
  return (
    <div className={`flex flex-col gap-10 ${containerClass}`}>
      <h2
        className={`my-0 text-putty-300 italic font-bold md:text-4xl tracking-[-0.06rem] text-3xl ${titleFontClass}`}
      >
        {title}
      </h2>
      <ul className={`flex flex-col gap-4 text-white ${descriptionListClass}`}>
        {details?.map((item) => (
          <li key={item.heading} className="flex items-start gap-4">
            <div className="w-5 h-6 translate-y-1">
              <Icon
                type="circle-check-outline"
                svgProps={{ width: "20", height: "20" }}
                pathProps={{ fill: iconColor }}
              />
            </div>
            <div className={`text-base ${descriptionFontClass}`}>
              <b>{item.heading}</b>
              {item.description}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
